__turbopack_context__.v({
  "apple": "styles-module-scss-module__fyobzW__apple",
  "facebook": "styles-module-scss-module__fyobzW__facebook",
  "selected": "styles-module-scss-module__fyobzW__selected",
  "socialButton": "styles-module-scss-module__fyobzW__socialButton",
});
